import { CriterionTemplate } from '@evidentid/tprm-portal-lib/models/decisioning/Criterion.model';

import { fieldsUseNewJsonForm } from '@/modules/decisioning-criteria/components/DynamicCriterionSetting/constants';
import {
    RECOLLECTION_INTERVAL_CRITERION_FIELD,
} from '@/modules/decisioning-criteria/utils/recollectionIntervalCriterion';

export function isNewJsonSchemaForm(template: CriterionTemplate): boolean {
    return fieldsUseNewJsonForm.includes(template.field);
}

export function isPublicOrProductsLiability(template: CriterionTemplate): boolean {
    return [
        'coverage.publicLiability',
        'coverage.productsLiability',
    ].includes(template.field);
}

export function isRecollectionIntervalCriterion(template: CriterionTemplate): boolean {
    return template.field === RECOLLECTION_INTERVAL_CRITERION_FIELD;
}
